// Dropdown
import React, { PropsWithChildren, useState } from 'react';
import cn from 'classnames';
import styles from './Dropdown.module.sass';
import { OptionValue } from 'types/common';
import useOutsideClick from 'hooks/useOutsideClick';

export interface DropdownProps<T extends string> {
  value: T | undefined;
  setValue: (value: T) => void;
  options: OptionValue<T>;
  label?: string;
  upBody?: boolean;
  small?: boolean;
  className?: string;
  classDropdownLabel?: string;
  classDropdownHead?: string;
  classDropdownSelection?: string;
  classMenu?: string;
}

const Dropdown = <P extends string>({
  value,
  setValue,
  options,
  label,
  upBody,
  small,
  className,
  classDropdownLabel,
  classDropdownHead,
  classDropdownSelection,
  classMenu,
}: PropsWithChildren<DropdownProps<P>>): JSX.Element => {
  const [visible, setVisible] = useState(false);
  const ref = useOutsideClick(() => {
    setVisible(false);
  });

  const handleSelect = (value: P) => {
    setVisible(false);
    setValue(value);
  };

  const selectedLabel = options.find((o) => o.value === value)?.label || '';

  return (
    <>
      {label && (
        <div className={cn(styles.label, classDropdownLabel)}>
          {label}
          {/* {tooltip && (
            <Tooltip
              className={styles.tooltip}
              title={tooltip}
              icon="info"
              place="right"
            />
          )} */}
        </div>
      )}
      <div
        className={cn(styles.dropdown, className, {
          [styles.small]: small,
          [styles.active]: visible,
        })}
        ref={ref}
      >
        <div
          className={cn(styles.head, classDropdownHead)}
          onClick={() => setVisible(!visible)}
        >
          <div className={cn(styles.selection, classDropdownSelection)}>
            {selectedLabel}
          </div>
        </div>
        <div
          className={cn(styles.body, classMenu, {
            [styles.bodyUp]: upBody,
          })}
        >
          {options.map(({ value: selectValue, label }, index) => (
            <div
              className={cn(styles.option, {
                [styles.selected]: selectValue === value,
              })}
              onClick={() => handleSelect(selectValue)}
              key={index}
            >
              {label}
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default Dropdown;
